import { OptionDB, type OptionDBType } from "@project/emerge";
import groupBy from "lodash/groupBy";
import data from "../../../shared/src/data.json";

const options = groupBy(data, "kind");
export const OptionDBInstance = new OptionDB(
  options as unknown as OptionDBType,
);
